import { authAPI } from '../../api/index'

const state = {
  user: null,
  token: localStorage.getItem('token') || null,
  isAuthenticated: false, // Se actualizará mediante checkAuth
  loading: false,
  error: null
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
    state.isAuthenticated = !!user
  },
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  async login({ commit }, credentials) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      // Credentials received - handled silently
      const response = await authAPI.login(credentials)
      const { user, token } = response.data
      // User logged in successfully - handled silently
      commit('SET_USER', user)
      commit('SET_TOKEN', token)
      
      return { success: true, user }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al iniciar sesión'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async logout({ commit }) {
    try {
      await authAPI.logout()
    } catch (error) {
      // Error during logout - handled silently
    } finally {
      commit('SET_USER', null)
      commit('SET_TOKEN', null)
    }
  },

  async register({ commit }, userData) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const response = await authAPI.register(userData)
      const { user, token } = response.data
      
      commit('SET_USER', user)
      commit('SET_TOKEN', token)
      
      return { success: true, user }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al registrar usuario'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async checkAuth({ commit }) {
    try {
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }
      
      commit('SET_TOKEN', token)
      const response = await authAPI.me()
      commit('SET_USER', response.data)
      return true
    } catch (error) {
      commit('SET_USER', null)
      commit('SET_TOKEN', null)
      return false
    }
  },

  async updateProfile({ commit }, profileData) {
    try {
      commit('SET_LOADING', true)
      const response = await authAPI.updateProfile(profileData)
      commit('SET_USER', response.data)
      return response.data
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al actualizar perfil'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async changePassword({ commit }, passwordData) {
    try {
      commit('SET_LOADING', true)
      await authAPI.changePassword(passwordData)
      return { success: true }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al cambiar contraseña'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async initialize({ dispatch }) {
    try {
      await dispatch('checkAuth')
    } catch (error) {
      // Error initializing auth module - handled silently
    }
  },

  async forgotPassword({ commit }, email) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      await authAPI.forgotPassword(email)
      return { success: true }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al enviar email de recuperación'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async resetPassword({ commit }, resetData) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      await authAPI.resetPassword(resetData)
      return { success: true }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al restablecer contraseña'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  user: state => state.user,
  token: state => state.token,
  loading: state => state.loading,
  error: state => state.error,
  
  isAdmin: state => state.user && state.user.role === 'admin',
  isManager: state => state.user && state.user.role === 'manager',
  isOperator: state => state.user && state.user.role === 'operator',
  userPermissions: state => state.user ? state.user.permissions || [] : []
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 


// WEBPACK FOOTER //
// ./src/store/modules/auth.js